<container-element [ngSwitch]="this.operation">
  <!-- Add -->
  <div *ngSwitchCase="1">
    <div>
      <div class="d-flex flex-row types__buisness justify-content-between">
        <div class="">{{ 'VENUES.ASSIGNED_HOSTS' | translate }}</div>
        <!-- <div *ngIf="checkedList.length == 0" class="alert alert-danger">
          <div class="d-flex flex-row alert-danger-content">
              <span>{{ 'INFO.INVALID_INPUT' | translate }}</span>
              <div class="alert-danger-info" matTooltipClass="tooltip-danger" matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
                <div>?</div>
              </div>
          </div>
        </div> -->
      </div>
      <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [style]="{width:'492px',position:'absolute'}" [options]="hostList" (onChange)="shareCheckedlist()"
      [(ngModel)]="checkedList" defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="firstName"
      [maxSelectedLabels]="2" selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
      <ng-template pTemplate="header">
        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
      </ng-template>
    </p-multiSelect>
    </div>
  </div>
  <!-- Edit -->
  <div *ngSwitchCase="2">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div class="">{{ 'VENUES.ASSIGNED_HOSTS' | translate }}</div>
      <!-- <div *ngIf="checkedList.length == 0" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
            <span>{{ 'INFO.INVALID_INPUT' | translate }}</span>
            <div class="alert-danger-info" matTooltipClass="tooltip-danger" matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
              <div>?</div>
            </div>
        </div>
      </div> -->
    </div>
    <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [style]="{width:'492px',position:'absolute'}" [options]="hostList" (onChange)="shareCheckedlist()"
      [(ngModel)]="checkedList" defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="firstName"
      [maxSelectedLabels]="2" selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
      <ng-template pTemplate="header">
        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
      </ng-template>
    </p-multiSelect>
  </div>
  <!-- Read -->
  <div *ngSwitchCase="4">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div class="">{{ 'VENUES.ASSIGNED_HOSTS' | translate }}</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <span>{{ 'INFO.INVALID_INPUT' | translate }}</span>
          <div class="alert-danger-info" matTooltipClass="tooltip-danger"
            matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [style]="{width:'492px',position:'absolute'}" [options]="hostList" [(ngModel)]="checkedList" [required]="true" #item="ngModel"
      defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name" optionDisabled="name"
      [maxSelectedLabels]="2" selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
      <ng-template pTemplate="header">
        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
      </ng-template></p-multiSelect>
  </div>

  <!--default case when there are no matches -->
  <div *ngSwitchDefault>...</div>
</container-element>